// @react/hooks/useSubscriptionDiscount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionDiscountStore } from '@core/stores';

/**
 * React hook for Discount operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscriptionDiscount } from '@react/hooks';
 *
 * const DiscountList = observer(() => {
 *   const store = useSubscriptionDiscount();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscriptionDiscount() {
  return subscriptionDiscountStore;
}
